angular.module('hj.preventInertia', []);

angular.module('hj.preventInertia').constant('Lethargy', Lethargy);

angular.module('hj.preventInertia').directive('hjPreventInertia', ['Lethargy', function(Lethargy) {
    'use strict';
    return {
        restrict: 'A',
        link: function($scope, $element, $attr) {

            var lethergy = new Lethargy();

            var wheelHandler = function(event) {
                if (lethergy.check(event) === false) {
                    event.preventDefault();
                }
            };

            $element.on('mousewheel', wheelHandler);
            $element.on('DOMMouseScroll', wheelHandler);

        }
    };
}]);
